import { render } from "./XmlAttributeName.vue?vue&type=template&id=17010745&scoped=true"
import script from "./XmlAttributeName.vue?vue&type=script&lang=js"
export * from "./XmlAttributeName.vue?vue&type=script&lang=js"

import "./XmlAttributeName.vue?vue&type=style&index=0&id=17010745&scoped=true&lang=css"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_vue@3.4.21_webpack@5.91.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17010745"]])

export default __exports__